import { createBasicSelector } from 'util/redux'
import { selectCurrentConversationById } from '.'
import { getInvertStateActionLabel } from '../utils/state'

export const selectConversationInvertStateActionLabelByConversationId = createBasicSelector(
  selectCurrentConversationById,
  ticket => getInvertStateActionLabel(ticket.state)
)
